import Timeslot from "./timeslot"
import EditTimes from "./edit"
import React from "react"
import _ from "underscore"
import { Badge } from '@/components/ui/badge'

class DailyTimeslots extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      expanded: false
    }
  }

  onCancelEdit = () => {
    this.setState({ expanded: false })
  }

  onToggleEdit = () => {
    this.setState({ expanded: !this.state.expanded })
  }

  onEditTimes = (timeslots) => {
    const updated_daily_timeslots = {
      day_of_week: this.props.day_of_week,
      timeslots: timeslots
    }

    this.props.onEditTimes(updated_daily_timeslots)
    this.onToggleEdit()
  }

  render() {
    const daily_timeslots = this.props.daily_timeslots

    return(
      <div className="py-2 first:pt-0 last:pb-0">
        <div className="flex items-center gap-3">
          <span className="w-10 shrink-0 text-xs font-semibold uppercase text-muted-foreground">
            {daily_timeslots.name}
          </span>
          {!this.state.expanded &&
            <div className="flex cursor-pointer flex-wrap items-center gap-1.5" onClick={this.onToggleEdit}>
              {daily_timeslots.timeslots.length === 0 ?
                <Badge variant="secondary">Click to add time</Badge>
                :
                <React.Fragment>
                  {_.map(daily_timeslots.timeslots, (timeslot, index) => {
                    return (
                      <span key={index} className="rounded-md bg-muted px-2 py-0.5 text-xs font-medium">
                        <Timeslot
                          start_time={timeslot.start_time}
                          end_time={timeslot.end_time}
                        />
                      </span>
                    )
                  })}
                </React.Fragment>
              }
            </div>
          }
        </div>
        {this.state.expanded &&
          <div className="mt-2">
            <EditTimes
              day_of_week={this.props.day_of_week}
              times={daily_timeslots.timeslots}
              onEditTimes={this.onEditTimes}
              onCancelEdit={this.onCancelEdit}
            />
          </div>
        }
      </div>
    )
  }
}

export default DailyTimeslots
